var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"height":"100%","width":"100%"}},[_c('div',[_vm._v(" 选择报告类型 ")])])
}]

export { render, staticRenderFns }